export default "__VITE_ASSET__bf2590b3__"